import { Stack, Typography, Button, useTheme, Card, CardMedia } from '@mui/material';
import { Link } from 'react-router';
import useMediaQuery from '@mui/material/useMediaQuery';

interface Props {
  title: string;
  intro?: string;
  url: string;
  imageUrls?: {
    landscape?: string;
  };
  imageUrl: string;
  imagePlacement: 'left' | 'right';
}

export function FeaturedArticle({ title, intro, imageUrl, imageUrls, url, imagePlacement }: Props) {
  const { palette, breakpoints } = useTheme();

  const matchesMd = useMediaQuery(breakpoints.down('md'));

  const resolvedImageUrl = matchesMd && imageUrls?.landscape ? imageUrls?.landscape : imageUrl;

  return (
    <Card sx={{ padding: 0 }}>
      <Stack
        minHeight={360}
        sx={{
          flexDirection: imagePlacement === 'left' ? 'row-reverse' : 'row',
          gap: 2,
          [breakpoints.down('md')]: {
            gap: 3,
            flexDirection: 'column-reverse',
          },
        }}
      >
        <Stack
          padding={{ xs: 0, sm: 2, md: 6 }}
          spacing={{ xs: 2, md: 3 }}
          justifyContent="center"
          alignItems="flex-start"
          sx={{
            flex: '1 0 50%',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              textWrap: 'balance',
              hyphens: 'auto',
            }}
          >
            {title}
          </Typography>
          {intro && (
            <Typography variant="h6" component="p" fontWeight={500} lineHeight={28 / 20}>
              {intro}
            </Typography>
          )}
          <Button
            variant="contained"
            color={palette?.brand ? 'brand' : 'secondary'}
            to={url}
            component={Link}
          >
            Les mer
          </Button>
        </Stack>

        <Stack
          sx={{
            flex: '1 0 50%',
            position: 'relative',
            [breakpoints.down('md')]: {
              aspectRatio: 16 / 9,
            },
          }}
        >
          <CardMedia
            component="img"
            height={360}
            image={resolvedImageUrl}
            sx={{
              display: 'flex',
              alignItems: 'center',
              objectFit: 'cover',
              objectPosition: 'center',
              width: '100%',
              borderRadius: 0,
              height: '100%',
              position: 'absolute',
            }}
          />
        </Stack>
      </Stack>
    </Card>
  );
}
